export const Content = [
    {
        key: 1,
        name: 'Arjun Asudani',
        image: require('static/team/content/arjun-asudani.png'),
        link: '',
    },  {
        key: 2,
        name: 'Ashish Basetty',
        image: require('static/team/content/ashish-basetty.png'),
        link: '',
    }, {
        key: 3,
        name: 'Michael Bunte',
        image: require('static/team/content/michael-bunte.png'),
        link: '',
    }, {
        key: 4,
        name: 'Jaanya Chawla',
        image: require('static/team/content/jaanya-chawla.png'),
        link: '',
    }, {
        key: 4,
        name: 'Aileen Chen',
        image: require('static/team/content/aileen-chen.png'),
        link: '',
    }, {
        key: 5,
        name: 'Alexander Chien',
        image: require('static/team/content/alexander-chien.png'),
        link: '',
    }, {
        key: 6,
        name: 'Cindy Ding',
        image: require('static/team/content/cindy-ding.png'),
        link: '',
    }, {
        key: 7,
        name: 'Zinnia Kwan',
        image: require('static/team/content/zinnia-kwan.png'),
        link: '',
    }, {
        key: 8,
        name: 'Ashvin Loghashankar',
        image: require('static/team/content/ashvin-loghashankar.png'),
        link: '',
    }, {
        key: 9,
        name: 'Jason Lozada',
        image: require('static/team/content/jason-lozada.png'),
        link: '',
    }, {
        key: 10,
        name: 'Grace Mao',
        image: require('static/team/content/grace-mao.jpg'),
        link: '',
    }, {
        key: 11,
        name: 'Meet Modi',
        image: require('static/team/content/meet-modi.png'),
        link: '',
    }, {
        key: 12,
        name: 'Emily Nham',
        image: require('static/team/content/emily-nham.png'),
        link: '',
    }, {
        key: 14,
        name: 'Isha Rajput',
        image: require('static/team/content/isha-rajput.png'),
        link: '',
    }, {
        key: 15,
        name: 'Paige Wu',
        image: require('static/team/content/paige-wu.png'),
        link: '',
    }, 
];
